import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const CategoryInformation = styled.div`
  color: ${({ theme }) => theme.text.tertiary};
  font-size: ${layout.fontSizes.base.desktop.rem};
  margin: ${layout.spacing.xSmall} 0;
`;
